import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=b8d1c2ac&scoped=true"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"
import style0 from "./Validate.vue?vue&type=style&index=0&id=b8d1c2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d1c2ac",
  null
  
)

/* custom blocks */
import block0 from "./Validate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports